import { render, staticRenderFns } from "./FlexibleBenefits.vue?vue&type=template&id=5dd4ce54&scoped=true"
import script from "./FlexibleBenefits.vue?vue&type=script&lang=js"
export * from "./FlexibleBenefits.vue?vue&type=script&lang=js"
import style0 from "./FlexibleBenefits.vue?vue&type=style&index=0&id=5dd4ce54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd4ce54",
  null
  
)

export default component.exports